import { motion } from 'framer-motion';

export interface RoomData {
  id: string;
  name: string;
  playersCount: number;
  maxPlayers: number;
  speed: 'slow' | 'normal' | 'fast';
  status: string;
  type: 'beginner' | 'fast' | 'private' | 'public';
}

interface RoomCardProps {
  room: RoomData;
  onJoin: (roomId: string) => void;
}

export function RoomCard({ room, onJoin }: RoomCardProps) {
  const speedColors = {
    slow: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
    normal: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
    fast: 'bg-pink-500/10 text-pink-400 border-pink-500/20',
  };

  return (
    <motion.div
      whileHover={{ y: -1 }}
      className="p-3.5 rounded-2xl bg-slate-950/20 hover:bg-slate-950/40 border border-white/5 hover:border-white/10 flex items-center justify-between transition-all duration-300 group"
    >
      <div className="flex flex-col text-left space-y-1.5">
        {/* Room Name */}
        <div className="flex items-center space-x-2">
          <span className="font-bold text-white text-xs tracking-wide group-hover:text-purple-300 transition-colors">
            {room.name}
          </span>
          <span className={`px-1.5 py-0.5 rounded text-[8px] font-black uppercase tracking-widest border ${speedColors[room.speed]}`}>
            {room.speed}
          </span>
        </div>

        {/* Players & Status */}
        <div className="flex items-center space-x-3 text-[10px] text-surface-400 font-semibold tracking-wide">
          <span className="flex items-center space-x-1">
            <span>👥</span>
            <span className="font-mono text-white/80">
              {room.playersCount} / {room.maxPlayers}
            </span>
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse" />
          <span className="text-amber-400/90 uppercase tracking-widest text-[9px] font-bold">
            {room.status}
          </span>
        </div>
      </div>

      {/* Join Action button */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => onJoin(room.id)}
        className="px-4 py-1.5 rounded-full bg-purple-600 hover:bg-purple-500 text-white font-extrabold text-[10px] uppercase tracking-widest transition-colors cursor-pointer shadow-md"
      >
        Join
      </motion.button>
    </motion.div>
  );
}
